import { useState, useRef, useCallback, useEffect } from 'react';
import { useAuth } from '../providers/AuthContext';

const LOGIN_TIMEOUT = 8000;

/**
 * Triggers signIn with an 8s timeout fallback.
 * Returns { loginFailed, triggerSignIn, reset }.
 */
export function useSignInWithTimeout() {
  const { signIn } = useAuth();
  const [loginFailed, setLoginFailed] = useState(false);
  const timeoutRef = useRef(null);

  const triggerSignIn = useCallback(() => {
    timeoutRef.current = setTimeout(() => setLoginFailed(true), LOGIN_TIMEOUT);
    signIn().catch(() => setLoginFailed(true));
  }, [signIn]);

  const reset = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setLoginFailed(false);
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => { if (timeoutRef.current) clearTimeout(timeoutRef.current); };
  }, []);

  return { loginFailed, triggerSignIn, reset };
}
